import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const VisitorUploadsSubtitle: FC<IOuter> = () => <FormattedMessage id="empty-state.visitor-uploads-subtitle" />;
